export const userSelect = (value: string) => ({
  'user-select': value,
  '-webkit-user-select': value,
  '-moz-user-select': value,
})
